"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  spacings: {
    xxsmall: '0.6rem',
    xsmall: '0.8rem',
    small: '1.6rem',
    medium: '2.4rem',
    large: '3.2rem',
    xlarge: '4.0rem',
    xxlarge: '4.8rem',
    huge: '5.6rem',
    xhuge: '6.4rem',
    xxhuge: '7.2rem',
    super: '8rem'
  },
  colors: {
    // New HHQ Colors
    background: '#151515',
    input: '#5E5E5E',
    // Palette Colors
    primary: '#222222',
    primaryDark: '#0F0F0F',
    secondary: '#BE433C',
    secondaryDark: '#9B1E20',
    error: '#F44336',
    errorDark: '#D32F2F',
    warning: '#B39670',
    warningDark: '#9B703C',
    info: '#FFBD32',
    infoDark: '#CA932B',
    success: '#7FC382',
    successDark: '#4EAA4E',
    // Button Colors
    buttonBackground: '#BB433C',
    buttonText: '#FFFFFF',
    buttonTextHover: '#FFFFFF',
    // Text Colors
    secondaryHeadingText: '#FFFFFF',
    secondaryBodyText: '#E5E5E5',
    // Other Colors
    white: '#FFFFFF',
    cultured: '#F7F7F7',
    lightSilver: '#D6D6D6',
    silverGrey: '#CCCCCC',
    silverChalice: '#ADADAD',
    dustyGrey: '#999999',
    // Opacity Colors
    blackOpacity: '#00000000',
    secondaryOpacity: '#BE433C00',
    // Website
    arsenic: '#424242',
    blackOlive: '#3E3E3E',
    darkCharcoal: '#303030',
    chineseBlack: '#151617',
    eerieBlack: '#1C1C1C',
    charlestonGreen: '#2c2c2c',
    graniteGray: '#656565',
    platinum: '#e8e8e8',
    vampireBlack: '#070707'
  },
  border: {
    radius: {
      small: '0.2rem',
      default: '0.4rem',
      large: '1rem',
      huge: '2rem'
    }
  },
  transitions: {
    default: '0.3s ease-in-out',
    quick: '0.1s ease-in-out'
  },
  fonts: {
    family: {
      fontAwesome: 'FontAwesome',
      montserrat: 'Montserrat',
      robotoFlex: 'Roboto Flex'
    },
    weight: {
      extraLight: 200,
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
      extraBold: 800,
      black: 900
    },
    sizes: {
      xxxsmall: '0.8rem',
      xxsmall: '1rem',
      xsmall: '1.2rem',
      small: '1.4rem',
      subtitle: '1.6rem',
      medium: '1.8rem',
      large: '2.0rem',
      xlarge: '2.4rem',
      xxlarge: '2.8rem',
      huge: '3rem',
      xhuge: '3.8rem'
    },
    lineHeight: {
      xxsmall: '1.6rem',
      xsmall: '2rem',
      small: '2.2rem',
      medium: '2.4rem',
      large: '2.8rem',
      xlarge: '3.2rem',
      xxlarge: '3.8rem'
    },
    spacings: {
      xsmall: '0.8rem',
      small: '1.6rem',
      medium: '2.4rem',
      large: '3.2rem',
      xlarge: '4.0rem',
      xxlarge: '4.8rem',
      huge: '5.6rem',
      xhuge: '6.4rem'
    }
  }
};
exports.default = _default;